var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"msg-box"},[_c('h1',{staticClass:"animated fadeInDown"},[_vm._v(_vm._s(_vm.$t("not_found.title")))]),_c('h2',{staticClass:"animated fadeInUp"},[_vm._v("\n\t\t\t"+_vm._s(_vm.$t("not_found.description_1"))),_c('br'),_vm._v(_vm._s(_vm.$t("not_found.description_2"))+"\n\t\t")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }